import { useContext, useState, useEffect } from 'react'
import { Box, Textarea, HStack, Stack, Image } from '@chakra-ui/react'
import { GameContext } from '../GameContextF.jsx'
import { useAction } from '../useAction.js'
import { NagArea } from './NagAreaF.jsx'
import { CanvasGameDraw } from '../CanvasGameDrawF.jsx'
import { PtBtn, Ptext} from '../../../componentsF/Chakra3F/ChakraF.jsx'
import { AiPromptBtn } from './AiPromptF.jsx'
import { useAutoSubmit } from './useAutoSubmitAI.jsx'

const fontSize = '3xl'

export const PleaseDescribe = () => {
  const {myState: {taskPrompt, assignedStackName}} = useContext(GameContext)

  const [descriptionText, setDescriptionText] = useState('')

  const {doAction, loading} = useAction({playerAction: 'submitDescription', descriptionText, assignedStackName})
  const isDisabled = descriptionText.length <= 3
  const onClick = () => {
    if (isDisabled) return
    doAction?.()
  }
  
  useAutoSubmit({ hasContent: descriptionText.length > 3, doSubmit: doAction })

  useEffect(() => {
    window.scrollTo({ top: 0 })
    return () => {}
  }, [])

  return <>
    <NagArea />
    <Textarea {...{
      'data-testid': 'description-input',
      onChange: (evt) => setDescriptionText(evt.target.value),
      textAlign: 'center', size: 'sm', fontSize: 'xl',
      defaultValue: descriptionText
    }} />
    <HStack {...{mb: 20, justifyContent: 'space-evenly', mt: 3}}>
      <PtBtn {...{'data-testid': 'submit-description-btn', onClick, isLoading: loading, isDisabled, colorScheme: 'green'}}>
        Submit
      </PtBtn>
      {!taskPrompt && <>
        <AiPromptBtn {...{setDescriptionText}} />
      </>}
    </HStack>
  </>
}

const isImageDataUrl = (val) => typeof val === 'string' && val.startsWith('data:image/')
const isImageSrc = (val) => typeof val === 'string'

export const DescribeDrawing = () => {
  const {myState} = useContext(GameContext)
  const {taskPrompt} = myState
  const imageSrc = isImageDataUrl(taskPrompt) ? taskPrompt
    : isImageSrc(taskPrompt) ? `/ipfs/${taskPrompt}.bin`
    : null

  return <>
    <Box {...{fontSize, mt: 4}}>
      <Ptext>Describe this drawing:</Ptext>
    </Box>
    <Stack>
      {imageSrc
        ? <Image {...{src: imageSrc, maxW: 600, maxH: 600, w: '100%', alignSelf: 'center'}} />
        : <CanvasGameDraw {...{finishedTrails: taskPrompt, readonly: true}} />}
      <PleaseDescribe />
    </Stack>
  </>
}